import { useLicensingServiceV1 } from "@rw1/api-services";
import { Licensing_V1 } from "@rw1/auto-generated-clients";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

export const WHITELIST_BY_LICENSE_ID_QUERY_KEY = "whitelist-by-license-id";

export interface UseWhitelistByLicenseIdProps {
  licenseId?: string;
  enabled?: boolean;
}

export const useWhitelistByLicenseId = ({
  licenseId,
  enabled = true,
}: UseWhitelistByLicenseIdProps): UseQueryResult<
  Licensing_V1.WhitelistEntry[]
> => {
  const licensingService = useLicensingServiceV1();

  return useQuery({
    queryKey: [WHITELIST_BY_LICENSE_ID_QUERY_KEY, licenseId],
    queryFn: async () => {
      if (!licenseId) {
        throw new Error("License ID is required");
      }

      return await licensingService.getLicenseWhitelist(licenseId);
    },
    enabled: !!licenseId && enabled,
  });
};
